import React, { useState } from "react";
import {
  Box,
  Modal,
  IconButton,
  Typography,
  Button,
  Stack,
  TableContainer,
  Table,
  TableCell,
  TableBody,
  TableRow,
} from "@mui/material";
import { Visibility } from "@mui/icons-material";
import Loader from "../ui/Loader";

import {
  imageDefaultStyleContain,
  sxFancyTableBorder,
  sxTableActionButtonBorder,
  activeIndicateColor,
  inActiveIndicateColor,
} from "../../theme/globalStyles";
import { customColor } from "../../theme/variants";
import { getSliderById } from "../../api/slider";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "calc(100% - 30vw)",
  maxHeight: "calc(100% - 20vh)",
  overflowY: "scroll",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 10,
  borderRadius: "24px",
  "::-webkit-scrollbar": {
    background: "transparent",
  },
  "::-webkit-scrollbar-thumb": {
    background: customColor[100],
    borderRadius: "24px",
  },
};

export default function ViewSlider({ id }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});

  const fetchSlider = () => {
    setLoading(true);
    getSliderById(id)
      .then((response) => {
        setLoading(false);
        setData(response.data.payload);
        console.log(response.data.payload);
      })
      .catch((error) => handleClose());
  };

  const handleOpen = () => {
    setOpen(true);
    fetchSlider();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const sxTableCell = {
    py: 1,
    px: 2,
    fontSize: "15px",
    width: "100%",
  };

  return (
    <div>
      <IconButton
        color="secondary"
        sx={{ ...sxTableActionButtonBorder }}
        onClick={handleOpen}
      >
        <Visibility />
      </IconButton>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          {loading ? (
            <Loader />
          ) : (
            <>
              <Box sx={{ mt: 5 }}>
                <Box sx={{ width: "70%", height: "20%", margin: "auto" }}>
                  <img
                    src={data?.imageFile?.fileUrl ?? "/default-image.png"}
                    alt=""
                    style={{
                      ...imageDefaultStyleContain,
                      borderRadius: "24px",
                      objectFit: "cover",
                    }}
                  />
                </Box>
              </Box>

              <Typography mt={5} variant="h2" align="center">
                {data.name}
              </Typography>
              <Stack
                mt={5}
                gap={{ xs: 5, md: 10 }}
                justifyContent={{ xs: "start", md: "space-between" }}
                alignItems={{ xs: "start", md: "center" }}
                direction={{ xs: "column", md: "row" }}
              >
                <TableContainer
                  sx={{
                    height: { xs: "250px", lg: "100%" },
                    "&::-webkit-scrollbar": {
                      background: customColor[100],
                      borderRadius: "5px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: customColor[200],
                      borderRadius: "5px",
                    },
                    mb: 3,
                  }}
                >
                  <Table
                    sx={{
                      ...sxFancyTableBorder,
                      minWidth: "280px",
                    }}
                  >
                    <TableBody sx={{ width: "100%" }}>
                      <TableRow sx={{ width: "100%" }}>
                        <TableCell sx={sxTableCell}>
                          <strong>Id:</strong> {data?.id}
                        </TableCell>
                      </TableRow>

                      <TableRow sx={{ width: "100%" }}>
                        <TableCell sx={sxTableCell}>
                          <strong>Title:</strong> {data?.title ?? "Unavailable"}
                        </TableCell>
                      </TableRow>

                      <TableRow sx={{ width: "100%" }}>
                        <TableCell sx={sxTableCell}>
                          <strong>Message:</strong>{" "}
                          {data?.message ?? "Unavailable"}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell sx={sxTableCell}>
                          <Stack direction="row" gap={2}>
                            <strong>Status:</strong>{" "}
                            <Stack direction="row" gap={1} alignItems="center">
                              <div
                                style={{
                                  height: "8px",
                                  width: "8px",
                                  borderRadius: "8px",
                                  backgroundColor: data?.active
                                    ? activeIndicateColor
                                    : inActiveIndicateColor,
                                }}
                              ></div>
                              {(data?.active ? "Active" : "Inactive") ??
                                "not found"}
                            </Stack>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Stack>
              <Stack direction="row" justifyContent={"end"}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => handleClose()}
                >
                  Close
                </Button>
              </Stack>
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
}
